import React from 'react';


const Level3Headers: React.FC = () => {
  return (
    <>
      <div className='results-table-frame-tab-body-col'>
        <div className='results-table-frame-tab-body-col-cell1'>
          <div className='results-table-frame-tab-body-col-cell1-head'>
                Entity / Product Name
          </div>
        </div>
        <div className='results-table-frame-tab-body-col-cell1'>
          <div className='results-table-frame-tab-body-col-cell1-head'>
                Listing Country
          </div>
        </div>
        <div className='results-table-frame-tab-body-col-cell1'>
          <div className='results-table-frame-tab-body-col-cell1-head'>
                Agency
          </div>
        </div>
        <div className='results-table-frame-tab-body-col-cell1'>
          <div className='results-table-frame-tab-body-col-cell1-head'>
              List
          </div>
        </div>
        <div className='results-table-frame-tab-body-col-cell1'>
          <div className='results-table-frame-tab-body-col-cell1-head'>
              Date Added
          </div>
        </div>
        <div className='view-history-head-frame-cell-emptys'>
          <div className='view-history-head-frame-cell-cont'>
            <div className='view-history-head-frame-cell-cont-text'>
                  Remove Hit
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Level3Headers;
